import { render, staticRenderFns } from "./TemplateEditPageHeader.vue?vue&type=template&id=08447bac&scoped=true"
import script from "./TemplateEditPageHeader.vue?vue&type=script&lang=js"
export * from "./TemplateEditPageHeader.vue?vue&type=script&lang=js"
import style0 from "@/modules/Templates/assets/css/template-detail-header.css?vue&type=style&index=0&id=08447bac&prod&scoped=true&lang=css&external"
import style1 from "./TemplateEditPageHeader.vue?vue&type=style&index=1&id=08447bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08447bac",
  null
  
)

export default component.exports